module.exports = __webpack_public_path__ + "static/media/verified.fb85a999.svg";